import angular from 'angular';
import { IGeracaoDeMarcacoesPadraoListItem } from '../models/geracao-de-marcacoes-padrao.service.model';
import { GeracaoDeMarcacoesPadraoService } from '../geracao-de-marcacoes-padrao.service';
import { applyNsjTableInlineMobileLabels, buildNsjTableInlineMobileLabel } from '../../../../../utils/nsj-table';

export class GeracaoDeMarcacoesPadraoIndexController {

    static $inject = [
        '$rootScope',
        '$scope',
        '$state',
        'GeracaoDeMarcacoesPadraoService',
    ];

    public busy = false;
    public loading = false;
    public entities: IGeracaoDeMarcacoesPadraoListItem[] = [];

    public fields = applyNsjTableInlineMobileLabels([
            {
                value: 'created_at',
                label: 'Data de criação',
                type: 'date',
                style: 'title',
                copy: '',
                customCollumnHtml: () => {
                    let someHtmlVar = `
                        <span ng-bind="tableRowEntity.created_at | asDate | date: 'dd/MM/yyyy'"></span> às <span ng-bind="tableRowEntity.created_at | asDateTime | date: 'HH:mm'"></span>
                    `;
                    return someHtmlVar;
                },
            }, {
                value: 'created_by.nome',
                label: 'Criado por',
                type: 'string',
                style: 'title',
                copy: '',
            },
            {
                value: 'datainicial',
                label: 'Período',
                type: 'date',
                style: 'title',
                copy: '',
                customCollumnHtml: () => {
                    let someHtmlVar = `
                        <span ng-bind="tableRowEntity.datainicial | asDate | date: 'dd/MM/yyyy'"></span> a <span ng-bind="tableRowEntity.datafinal | asDate | date: 'dd/MM/yyyy'"></span>
                    `;
                    return someHtmlVar;
                },
            }, {
                value: 'status',
                label: 'Situação',
                type: 'string',
                style: 'title',
                copy: '',
                customCollumnHtml: () => {
                    let someHtmlVar = `
                        <label class="label {{tableRowEntity.status | situacaoGeracaoDeMarcacoesPadraoEnumClassEnum}}"
                        >
                            {{tableRowEntity.status | situacaoGeracaoDeMarcacoesPadraoEnum:tableRowEntity.statusreversao}}
                        </label>
                    `;
                  return someHtmlVar;
                },
            }, {
                value: 'importacaomarcacao',
                label: 'Ações',
                type: 'div',
                style: 'title',
                copy: '',
                customLabelHtml: buildNsjTableInlineMobileLabel('Ações', { showOnMobile: false }),
                customCollumnScope: {
                    visualizarSolicitacao: (entity: IGeracaoDeMarcacoesPadraoListItem) => {
                        this.busy = true;
                        this.$state.go('geracaodemarcacoespadrao_show', {
                            importacaomarcacao: entity.importacaomarcacao
                        });
                    },
                },
                customCollumnHtml: () => {
                    let someHtmlVar = `
                        <div class="display-flex justify-content-end-md">
                            <a
                                class="btn btn-tertiary btn-sm"
                                ng-click="customCollumnScope.visualizarSolicitacao(tableRowEntity)"
                            >
                                Ver detalhes
                            </a>
                        </div>
                    `;
                  return someHtmlVar;
                },
            }
    ]);

    constructor(
        public $rootScope: angular.IRootScopeService & {
            temPermissao: (arg: string) => boolean,
            liberadoTela: (arg: string) => boolean,
        },
        public $scope: angular.IScope,
        public $state: angular.ui.IStateService,
        public GeracaoDeMarcacoesPadraoService: GeracaoDeMarcacoesPadraoService,
    ) {
        this.refresh();

        $scope.$on('ponto_importacoesmarcacoes_index_loaded', (event, args: IGeracaoDeMarcacoesPadraoListItem[]) => {
            this.entities = args;
        });

        $scope.$on('ponto_importacoesmarcacoes_index_finished', (event, args: IGeracaoDeMarcacoesPadraoListItem[]) => {
            this.entities = args;
        });
    }

    refresh(): void {
        this.entities = [];
        this.GeracaoDeMarcacoesPadraoService.reload();
    }
}
